import { render, staticRenderFns } from "./customOtpInput.vue?vue&type=template&id=482ccd45&scoped=true"
import script from "./customOtpInput.vue?vue&type=script&lang=js"
export * from "./customOtpInput.vue?vue&type=script&lang=js"
import style0 from "./customOtpInput.vue?vue&type=style&index=0&id=482ccd45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ccd45",
  null
  
)

export default component.exports